import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useEffect, useState } from 'react';
import { Transition, NavigationToast } from '@wix/design-system';
import { StatusAlertSmall } from '@wix/wix-ui-icons-common';
export function Notification(_ref) {
  let {
    children,
    onDismiss,
    status,
    ...props
  } = _ref;
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  const renderIcon = useCallback(() => {
    if (status === 'error') {
      return /*#__PURE__*/React.createElement(StatusAlertSmall, null);
    }
    return undefined;
  }, [status]);
  return /*#__PURE__*/React.createElement(Transition, {
    show: show,
    enterAnimation: {
      fadeIn: {
        duration: 'slow02',
        easing: 'enterEasing'
      }
    }
  }, /*#__PURE__*/React.createElement(NavigationToast, _extends({}, props, {
    prefixIcon: renderIcon(),
    onDismiss: onDismiss
  }), children));
}
//# sourceMappingURL=Notification.js.map